import dotenv from 'dotenv';
import CsConstant from "./CsConstant";

dotenv.config();

const Env = {

  getApiKey: () => {
    return process.env.REACT_APP_SHOPIFY_API_KEY;
  },

  getEnvironment: () => {
    return process.env.REACT_APP_ENVIRONMENT;
  },

  isDevMode: () => {
    return "dev" === Env.getEnvironment();
  },

  isProdMode: () => {
    return 'production' === Env.getEnvironment();
  },

  log: (...args) => {
    if (!Env.isProdMode()) {
      console.log(...args);
    }
  },

  trace: (...args) => {
    if (!Env.isProdMode()) {
      console.trace(...args);
    }
  },

  getBackendURL: () => {
    return process.env.REACT_APP_BACKEND_APP_URL;
  },

  getHost: () => {
    return Env._getQueryParam('host');
  },

  getLocale: () => {
    return Env._getQueryParam('locale');
  },

  getCsToken: () => {
    return Env._getQueryParam(CsConstant.HEADER_HASHED_STORE);
  },

  getStoreName: () => {
    return Env._getQueryParam('shop');
  },

  getRefreshTranslation: () => {
    return !!Env._getQueryParam('refresh_translation');
  },

  getRefreshDocumentation: () => {
    return !!Env._getQueryParam('refresh_docs');
  },

  // Params on Shopify will be transferred all to BE, BE in turn ships all to FE.
  // window.location.search is always URL constructed by BE, includes any additional query params.
  _getQueryParam: (key) => {
    // console.log('-----Query', key, window.location.search);
    return new URLSearchParams(decodeURIComponent(window.location.search)).get(key);
  },
};

export default Env;
